// extracted by mini-css-extract-plugin
export default {"checkMessageButton":"CheckMessageButton_checkMessageButton__wvma9","checkMessageButtonDark":"CheckMessageButton_checkMessageButtonDark__89QX0"};